/**
 * Real-time tablet display only — same status icons as the Devices tab.
 * Pads are unchanged (original Real-time SLA + offline overlay).
 */
import utilService from '@/modules/common/services/utilService'

const DEVICE_OK_TIME = 1
const DEVICE_WARNING_TIME = 3

const ICON_ASSETS = {
  OK: require('@/assets/OK.svg'),
  OK_blue: require('@/assets/OK_blue.svg'),
  warning_blue: require('@/assets/warning_blue.svg'),
  warning_orange: require('@/assets/warning_orange.svg'),
  warning_red: require('@/assets/warning_red.svg'),
  offline: require('@/assets/offline.svg'),
}

function parseSensorNote(note) {
  if (!note) return null
  if (typeof note === 'string') {
    try {
      return JSON.parse(note)
    } catch {
      return null
    }
  }
  return note
}

function hasNoteText(note) {
  const parsed = parseSensorNote(note)
  return Boolean(parsed?.txt?.length)
}

function getHoursPassed(lastSignal) {
  if (!lastSignal || lastSignal === '0000') return Number.POSITIVE_INFINITY
  let date = new Date(lastSignal)
  if (Number.isNaN(date.getTime())) return Number.POSITIVE_INFINITY
  if (new Date().getTime() < date.getTime()) date = new Date()
  return utilService.getHoursPassed(date)
}

function getTabletIconName(isNoteTxt, hoursPassed) {
  if (hoursPassed < DEVICE_OK_TIME) {
    return isNoteTxt ? 'OK_blue' : 'OK'
  }
  if (hoursPassed < DEVICE_WARNING_TIME) {
    return isNoteTxt ? 'warning_blue' : 'warning_orange'
  }
  return isNoteTxt ? 'warning_blue' : 'warning_red'
}

export function isTabletDevice(sensorType) {
  return sensorType === 'tablet' || sensorType === 'Tablet'
}

function getTabletTooltipKey(lastSignal) {
  const hoursPassed = getHoursPassed(lastSignal)
  if (hoursPassed < DEVICE_OK_TIME) return 'online'
  if (hoursPassed < DEVICE_WARNING_TIME) return 'warning'
  return 'offline'
}

export function getRealTimeTabletStatusDisplay(room = {}) {
  const { last_signal, sensorNote } = room
  const isNoteTxt = hasNoteText(sensorNote)
  const hoursPassed = getHoursPassed(last_signal)
  const iconName = getTabletIconName(isNoteTxt, hoursPassed)
  return {
    iconAsset: ICON_ASSETS[iconName] || ICON_ASSETS.offline,
    tooltipKey: getTabletTooltipKey(last_signal),
  }
}

export function isOfflineTabletDisplay(room = {}) {
  if (!isTabletDevice(room.sensorType)) return false
  return getRealTimeTabletStatusDisplay(room).tooltipKey === 'offline'
}
